import {View, Text} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {tableStyles as styles} from './styles/recommendations-table-styles';
import {sharedStyles} from './styles/shared-styles';
import {ScreeningRecommendations} from '../../../../../types/ApplicantScreeningReport';

interface Props {
  t: TFunction;
  tableData: ScreeningRecommendations[];
  currentLanguage: 'en' | 'de';
}

export const RecommendationsTable = ({t, tableData, currentLanguage}: Props) => {
  return (
    <View style={styles.table}>
      {/* Table Header */}
      <View style={{...styles.tableRowHeader}}>
        <Text style={{...styles.tableCell, ...sharedStyles.h4, ...styles.firstColumn, ...styles.tableCellHeader}}>
          {t('screeningModule.report.recommendations.recommendationsPage1.tableHeader.pillar').toUpperCase()}
        </Text>
        <Text style={{...styles.tableCell, ...sharedStyles.h4, ...styles.matchColumn, ...styles.tableCellHeader}}>
          {t('screeningModule.report.recommendations.recommendationsPage1.tableHeader.match').toUpperCase()}
        </Text>
        <Text style={{...styles.tableCell, ...sharedStyles.h4, ...styles.tableCellHeader}}>
          {t('screeningModule.report.recommendations.recommendationsPage1.tableHeader.opportunities').toUpperCase()}
        </Text>
        <Text style={{...styles.tableCell, ...sharedStyles.h4, ...styles.tableCellHeader}}>
          {t('screeningModule.report.recommendations.recommendationsPage1.tableHeader.risks').toUpperCase()}
        </Text>
        <Text style={{...styles.tableCell, ...sharedStyles.h4, ...styles.tableCellHeader}}>
          {t('screeningModule.report.recommendations.recommendationsPage1.tableHeader.evaluation').toUpperCase()}
        </Text>
      </View>

      {/* Table Rows */}
      {tableData.map((data, idx) => (
        <View
          key={`${data.pillarTitle[currentLanguage]} ${idx}`}
          style={idx % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd}
          wrap={false}
        >
          <Text
            style={{
              ...styles.tableCell,
              ...styles.firstColumn,
              ...sharedStyles.h4,
              fontWeight: 'bold',
            }}
          >
            {data.pillarTitle[currentLanguage]}
          </Text>
          <Text style={{...styles.tableCell, ...sharedStyles.h4, ...styles.matchColumn, fontWeight: 'bold'}}>
            {data.overlap ? `${Math.trunc(data.overlap * 100)}%` : '-'}
          </Text>
          <Text style={{...styles.tableCell, ...sharedStyles.h4}}>
            {data.opportunities[currentLanguage].map((opp) => (
              <Text key={opp}>{`• ${opp.charAt(0).toUpperCase() + opp.slice(1)}\n`}</Text>
            ))}
          </Text>
          <Text style={{...styles.tableCell, ...sharedStyles.h4}}>
            {data.risks[currentLanguage].map((risk) => (
              <Text key={risk}>{`• ${risk.charAt(0).toUpperCase() + risk.slice(1)}\n`}</Text>
            ))}
          </Text>
          <Text style={{...styles.tableCell, ...sharedStyles.h4}}>
            {data.evaluations[currentLanguage].map((evaluation) => (
              <Text key={evaluation}>{`• ${evaluation.charAt(0).toUpperCase() + evaluation.slice(1)}\n`}</Text>
            ))}
          </Text>
        </View>
      ))}
    </View>
  );
};
